import './styles/Balota.css';

import { BALOTA_SIZES, BALOTA_STATES } from './constants';

// A single lottery ball showing one digit. Reused by the draw machine, the
// results history and the ticket list, so it lives in common/ rather than in
// whichever feature needed it first (TSS vite/01 §"Layer communication rules").

export default function Balota({
    digit,
    size = BALOTA_SIZES.MD,
    state = BALOTA_STATES.IDLE,
    muted = false,
}) {
    const classes = [
        'balota',
        `balota--${size}`,
        `balota--${state}`,
        muted ? 'balota--muted' : '',
    ].filter(Boolean).join(' ');

    return (
        <span className={classes}>
            <span className="balota__digit">{digit}</span>
        </span>
    );
}
